import React from 'react';
import { Loading } from 'common/loading';
import { Vehicles } from './components';
import { UseMyVehicles } from './use-my-vehicles';

export const VehiclesPage = () => {
  const props = UseMyVehicles();

  return (
    <div className="w-full h-full">
      {props.isLoading && <Loading />}
      <Vehicles {...props} />
    </div>
  );
};
